import React, { useState, useEffect } from 'react';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import { Row, Col, Container, Card } from 'reactstrap';
import EirAccordionTile from './EirAccordionTile';

function EirTwoColumnAccordion(props) {

    const renderContent = (content) => {
        return { __html: content };
    }

    //To get background based on device
    const getBackgroundImage = () => {
        if (isMobile && !isTablet) {
            return (props.mobileBackgroundImage) ? props.mobileBackgroundImage.path : '';
        }
        return (props.backgroundImage) ? props.backgroundImage.path : '';
    }

    const getBackgroundColor = () => {
        if (isMobile && !isTablet) {
            return (props.mobilebackgroundColor) ? props.mobilebackgroundColor : '';
        }
        return (props.backgroundColor) ? props.backgroundColor : '';
    }

    let acc_ctr_width;
    if (isMobileOnly) {
        acc_ctr_width = " col-sm-12 ";
    } else {
        (props.EirAccordion.length == 1) ? acc_ctr_width = " col-md-12 pl-0 pr-0 " : acc_ctr_width = " col-md-6 "
    }
    useEffect(() => {
        //below is to hide the comp for a sec so that the LHS RHS column pages render properly 
        setTimeout(() => {
            let accordionCtr = document.querySelectorAll(".two-col-acc");
            for (var i = 0; i < accordionCtr.length; i++) {
                accordionCtr[i].classList.remove("d-none");
            }
            if (isMobileOnly) {
                if (props.MobileDisplay === 'First') {
                    document.querySelectorAll(".outer-card")[1].classList.add("d-none");
                }
                else if (props.MobileDisplay === 'Second') {
                    document.querySelectorAll(".outer-card")[0].classList.add("d-none");
                }
            }
        }, 1000);
    })

    let displayMobile, displayDesktop;
    switch (props.Visibility) {
        case ("mobile-only"):
            {
                displayMobile = "";
                displayDesktop = " d-none ";
                break;
            }

        case ("desktop-only"):
            {
                displayMobile = " d-none ";
                displayDesktop = "";
                break;
            }
        case ("Both"):
            {
                displayMobile = "";
                displayDesktop = "";
                break;
            }

        case ("none"):
            {
                displayMobile = " d-none ";
                displayDesktop = " d-none ";
                break;
            }
        default: {
            displayMobile = "";
            displayDesktop = "";
            break;
        }
    }

    return (
        <div className={((!isMobile) ? displayDesktop : displayMobile)}>
            <div id={"eir-accordion-ctr-" + props.ComponentOccurence} className={'eir-business-page pt-2 pb-4 two-col-acc d-none '}>
                <div className={'pt-4  eir-accordion  ' + ((!isMobile) ? displayDesktop + ' pb-5 ' : displayMobile)} style={{
                    backgroundImage: "url(" + getBackgroundImage() + ")",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: getBackgroundColor(),
                }} >
                    <div className={(!isMobileOnly) ? '  eir-acc-desktop container ' : 'container'}>
                        {props.EirAccordion.map((tile, i) => {
                            return (
                                <div className={'  outer-div   ' + acc_ctr_width + ((isMobileOnly) ? ' outer-card ' : '') + ((props.EirAccordion.length == 2 && (i == 1)) ? ' pr-0  ' : ' pl-0 ')}>
                                    <Card id="" className={((isMobileOnly) ? ' ml-3 mr-3 accordion-card' : '') + (((!isMobileOnly) || (isTablet)) ? ' accordion-card ' : ' accordion-card-mobile')}>
                                        {/* <div className="accordion-title mt-3 mb-1 p-1" dangerouslySetInnerHTML={renderContent(tile.Title)}></div> */}                                       
                                        {tile.Title && (
                                            <div
                                                className="accordion-title mt-3 mb-1 p-1"
                                                dangerouslySetInnerHTML={renderContent(tile.Title)}
                                            />
                                        )}
                                        {tile.Subtext &&
                                            <div className={((isMobileOnly) ? 'ml-4' : 'ml-5') + " mr-3 accordion-header-copy p-1"} dangerouslySetInnerHTML={renderContent(tile.Subtext)}></div>}
                                        {tile.EirAccordionTile.map((accord, j) => {
                                            return (<div>
                                                <EirAccordionTile
                                                    id={props.ComponentOccurence}
                                                    index1={i}
                                                    index2={j}
                                                    Heading={accord.Heading}
                                                    Copy={accord.Copy}
                                                ></EirAccordionTile>
                                            </div>
                                            )
                                        })
                                        }
                                    </Card>
                                </div>
                            )
                        })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
export default EirTwoColumnAccordion;